// Thin client for the BYOM API (/api/manuals) + document listing.
// Every API call carries the user's Supabase JWT; the server verifies it.
import { supabase } from '../lib/supabaseClient';

async function getAccessToken() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) throw new Error('Please log in to manage manuals.');
  return token;
}

export async function callManualsApi(action, payload = {}) {
  const token = await getAccessToken();
  const res = await fetch('/api/manuals', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ action, ...payload }),
  });
  let json = null;
  try {
    json = await res.json();
  } catch {
    // non-JSON error body — fall through to the generic message
  }
  if (!res.ok) {
    throw new Error(json?.error || `Request failed (${res.status})`);
  }
  return json;
}

// Reads go straight through the Supabase client — RLS limits them to the
// logged-in user's own rows.
export async function listMyDocuments() {
  const { data, error } = await supabase
    .from('documents')
    .select('id, filename, equipment_path, status, chunk_count, created_at')
    .order('created_at', { ascending: false });
  if (error) throw new Error('Could not load your manuals.');
  return data || [];
}

export async function getMyPlan() {
  const { data } = await supabase.from('user_plans').select('plan, max_manuals, is_admin').single();
  return data || { plan: 'trial', max_manuals: 1, is_admin: false };
}
